import { defineStore } from 'pinia'
import artipoQuery from '../apollo/queries/pages/artipo.gql'

export const useArtIpoStore = defineStore('artIpo', {
  state: () => ({
    data: {}
  }),
  getters: {
    getData: (state) => {
      return state.data.artIpos ? state.data.artIpos.data : null
    }
  },
  actions: {
    async requestData() {
      if (Object.keys(this.data).length !== 0) return

      const { data } = await useAsyncQuery(artipoQuery) // eslint-disable-line no-undef

      if (data) this.data = data
    }
  }
})
